import { useLoginData } from "component/common/loginData";
import { USER_TYPE, USERS_LIST } from "helper/constant";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

const ActionDropdown = ({ isOpen, setIsOpen, isIcon }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const userData=useLoginData()
  const handleLogin = (e) => {
    e.stopPropagation();
    navigate("/login");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setIsOpen]);

  return (
    <div className="relative" ref={dropdownRef}>
      {!isIcon && (
        <div
          className="cursor-pointer rounded-full transition-colors"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen(!isOpen);
          }}
        >
          <svg
            className={`w-4 h-4 text-gray-400 transition-transform duration-300 ${
              isOpen ? "rotate-180 text-blue-400" : ""
            }`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="2.5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="m19 9-7 7-7-7"
            />
          </svg>
        </div>
      )}

      {isOpen && (
        <div
          className="absolute left-1/2 -translate-x-1/2 md:right-0 mt-2 sm:w-80 w-64 max-w-[90vw] z-[999]"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
            <div className="md:p-3 p-2 border-b">
              <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">
                Switch Account
              </h3>
            </div>

            <div>
              {USERS_LIST?.map((account, index) => (
                <button
                  key={index}
                  onClick={() => {
                    secureLocalStorage.setItem(
                      process.env.REACT_APP_TOKEN_STORAGE_KEY,
                      account?.token
                    );
                    secureLocalStorage.setItem(
                      process.env.REACT_APP_USER_STORAGE_KEY,
                      account?.data
                    );
                    navigate("/");
                    window.location.reload();
                  }}
                  className="w-full flex items-center lg:gap-3 gap-1 md:p-2 p-1 rounded-lg hover:bg-slate-100 transition-colors mb-1 last:mb-0"
                >
                  <div
                    style={{
                      backgroundImage:
                        account?.data?.venueImageUrl?.length > 0
                          ? `url("${account?.data?.venueImageUrl[0]}")`
                          : "",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    className="w-10 h-10 rounded-full bg-brand-gradient flex items-center justify-center text-white text-xs font-bold"
                  >
                    {account?.data?.venueImageUrl?.length > 0
                      ? ""
                      : account?.data?.name?.[0]?.toUpperCase()}
                  </div>
                  <div className="text-left">
                    <div>
                      <p className="text-sm font-semibold text-slate-700 w-48 truncate">
                        {account?.data?.name}{" "}
                        <span className="font-light text-xs">
                          ({USER_TYPE[account?.data?.userType]})
                        </span>
                      </p>
                      <p className="text-xs text-slate-800 w-48 truncate">
                        {account?.data?.email}
                      </p>
                      {account?.data?.id === userData?.id && (
                        <p className="text-xs font-medium text-green-600">
                          Active
                        </p>
                      )}
                    </div>
                  </div>
                </button>
              ))}
            </div>

            <div className="p-3 bg-slate-50 border-t flex justify-center">
              <button
                onClick={handleLogin}
                className="text-xs font-semibold text-[#2bace2] flex items-center gap-1"
              >
                + Add Account
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ActionDropdown;
